// 受注配車乳直一覧内の定数

export const 積卸日Bindings = ["積日", "卸日"]
export const 積地Bindings = ["積地社名", "積地都道府県", "積地市区町村"]
export const 卸地Bindings = ["卸地社名", "卸地都道府県", "卸地市区町村"]

export const 品名Bindings = [
  "品コード",
  "品名",
  "数量",
  "積載品数量",
  "単位区分コード",
  "単位区分名称1",
]

export const 車輌Bindings = [
  "運行部所コード",
  "傭車会社コード",
  "傭車会社名",
  "車番",
  "車種区分コード",
  "トレーラ車番",
  "最大積載量",
  "トレーラ車種区分コード",
  "乗務員名",
  "食事代",
  "同乗者1名",
]

export const 乗務員売上Bindings = [
  "食事手当",
  "乗務員売上額",
  "稼働手当車種掛率",
  "同乗者売上額",
]
export const 請求Bindings = [
  "請求内訳コード",
  "荷主請求内訳ID",
  "請求区分コード",
  "請求数量単価",
  "請求車番",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料税込区分名称",
  "請求高速料",
  "請求合計",
  "date請求計上日",
  "計上基準日区分名称",
  "請求備考",
]

export const 支払Bindings = [
  "傭車会社名",
  "支払運送料課税区分コード",
  "支払運送料",
  "支払付帯料課税区分コード",
  "支払付帯料",
  "支払高速料税込区分名称",
  "支払高速料",
  "支払合計",
  "date支払計上日",
  "支払備考",
]
